import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

// Compact thermal-style printable payment receipt. Props: clinic (Settings), payment (populated Payment doc)
const PrintableReceipt = ({ clinic, payment }) => {
  if (!payment) return null;
  const patient = payment.patient || {};
  const visit = payment.visit || {};

  return (
    <Box
      className="receipt-print-sheet"
      sx={{ width: '80mm', bgcolor: '#fff', color: '#2b2740', p: '4mm', mx: 'auto', fontFamily: '"Inter", monospace' }}
    >
      <Box sx={{ textAlign: 'center', mb: 1 }}>
        <Typography sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 800, fontSize: '1rem' }}>
          {clinic?.clinicName || 'EyeDealist Eye Clinic'}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block' }}>
          {[clinic?.address?.line1, clinic?.address?.city].filter(Boolean).join(', ')}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block' }}>
          {clinic?.phone}
        </Typography>
      </Box>
      <Divider sx={{ borderStyle: 'dashed', my: 1 }} />
      <Typography variant="body2" fontWeight={700} sx={{ textAlign: 'center', mb: 1 }}>PAYMENT RECEIPT</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption">Receipt No:</Typography>
        <Typography variant="caption" fontWeight={700}>{payment.receiptNumber}</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption">Date:</Typography>
        <Typography variant="caption">{new Date(payment.createdAt).toLocaleString('en-IN')}</Typography>
      </Box>
      <Divider sx={{ borderStyle: 'dashed', my: 1 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption">Patient:</Typography>
        <Typography variant="caption">{patient.name}</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption">Patient ID:</Typography>
        <Typography variant="caption">{patient.patientId}</Typography>
      </Box>
      {visit.visitId && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="caption">Visit / Token:</Typography>
          <Typography variant="caption">{visit.visitId} {visit.tokenNumber ? `/ #${visit.tokenNumber}` : ''}</Typography>
        </Box>
      )}
      <Divider sx={{ borderStyle: 'dashed', my: 1 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2">Amount Paid</Typography>
        <Typography variant="body2" fontWeight={700}>₹{payment.amount?.toFixed(2)}</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption">Mode:</Typography>
        <Typography variant="caption" sx={{ textTransform: 'uppercase' }}>{payment.mode}</Typography>
      </Box>
      {payment.transactionId && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="caption">Txn ID:</Typography>
          <Typography variant="caption">{payment.transactionId}</Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption">Collected By:</Typography>
        <Typography variant="caption">{payment.collectedBy?.name}</Typography>
      </Box>
      <Divider sx={{ borderStyle: 'dashed', my: 1 }} />
      <Typography variant="caption" sx={{ display: 'block', textAlign: 'center' }}>
        {clinic?.receiptFooterNote || 'Thank you!'}
      </Typography>
    </Box>
  );
};

export default PrintableReceipt;
